import { useState, useEffect, useCallback } from 'react'
import { cmsService } from '../../services/cmsService'
import { Field, SectionCard, PageHeader, SpinnerIcon, ImageUpload } from '../../components/cms/shared'

const PAGE = 'settings'
const SECTIONS = ['branding']

function initState() {
    return Object.fromEntries(SECTIONS.map((s) => [s, { saving: false, saved: false, error: null }]))
}

export default function SettingsCmsPage() {
    const [content, setContent] = useState({})
    const [pageLoading, setPageLoading] = useState(true)
    const [sectionState, setSectionState] = useState(initState())

    useEffect(() => {
        cmsService.getPage(PAGE).then((res) => { if (res?.data) setContent(res.data) }).catch(() => {}).finally(() => setPageLoading(false))
    }, [])

    const setSaving = (section, state) => setSectionState((prev) => ({ ...prev, [section]: { ...prev[section], ...state } }))

    const save = useCallback(async (section, payload) => {
        setSaving(section, { saving: true, saved: false, error: null })
        try {
            await cmsService.updateSection(PAGE, section, payload)
            setSaving(section, { saving: false, saved: true, error: null })
            setTimeout(() => setSaving(section, { saved: false }), 3000)
        } catch (err) {
            setSaving(section, { saving: false, saved: false, error: err.message || 'Save failed' })
        }
    }, [])

    const set = (section, field, value) => setContent((c) => ({ ...c, [section]: { ...(c[section] || {}), [field]: value } }))
    const sec = (k) => content[k] || {}

    if (pageLoading) return <div className="flex items-center justify-center py-24"><SpinnerIcon className="w-6 h-6 animate-spin text-brand-navy" /></div>

    return (
        <div className="space-y-6">
            <PageHeader title="Site Settings — Branding" description="Manage the logos shown across the public site." />

            <SectionCard title="Logos" description="Header and footer use separate logo images." onSave={() => save('branding', sec('branding'))} {...sectionState.branding}>
                <div className="grid md:grid-cols-2 gap-5">
                    <Field label="Header Logo">
                        <ImageUpload value={sec('branding').headerLogo} onChange={(v) => set('branding', 'headerLogo', v)} />
                    </Field>
                    <Field label="Footer Logo">
                        <ImageUpload value={sec('branding').footerLogo} onChange={(v) => set('branding', 'footerLogo', v)} />
                    </Field>
                </div>
            </SectionCard>
        </div>
    )
}
